import { render, staticRenderFns } from "./registered-athletes-pool.vue?vue&type=template&id=4edae86e&scoped=true&"
import script from "./registered-athletes-pool.vue?vue&type=script&lang=js&"
export * from "./registered-athletes-pool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edae86e",
  null
  
)

export default component.exports